import { addDays, startOfDay } from 'date-fns';
import {
    ExtendedRuleDefinition,
    Participant,
    Program,
    RetailerOptConfig,
    RetailerOptConfigStatusEnum,
    ConversionType,
    Rule,
} from '../../gen/api/api';

export interface ConfigurationFormInputs {
    id: string;
    program: string;
    retailer: string;
    name: string;
    description: string;
    startDateTime: string;
    endDateTime: string;
    status: string;
}

export interface RetailerOptConfigRich extends RetailerOptConfig {
    program: Program | null;
    retailer: Participant | null;
    ruleInputs: { [key: string]: any };
}

export enum EffectiveFactBehaviourEnum {
    MANDATORY = 'MANDATORY',
    IGNORED = 'IGNORED',
    OPTIONAL = 'OPTIONAL',
}

export interface ConfigurationFormProps {
    ruleDefinitions?: ExtendedRuleDefinition[];
    rules?: Rule[];
    onRulesInitialized?: () => void;
    setDirty?: (dirty: boolean) => void;
}

export const configurationFormInitialValues = {
    id: undefined,
    type: ConversionType.CURRENCYCONVERSION,
    programId: 0,
    retailerId: 0,
    name: '',
    description: '',
    startDateTime: new Date(startOfDay(addDays(new Date(), 1))).toISOString(),
    endDateTime: new Date(startOfDay(addDays(new Date(), 2))).toISOString(),
    status: RetailerOptConfigStatusEnum.DRAFT,
    program: null,
    retailer: null,
    ruleInputs: {},
};
